// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutWrapperSideNav_root__3_E-t","tabs":"LayoutWrapperSideNav_tabs__3tCNS","tab":"LayoutWrapperSideNav_tab__3EHLH"};